import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get } from "lodash";
import tenantConfig from "../../mocks/tenantOne.json";
import {
  FLOW_TYPES,
  getPathWithParam,
  MANAGE_COMPANY_ROUTES,
} from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiamond } from "@fortawesome/pro-solid-svg-icons";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";
const ManageCompanyMenu = ({
  menuList = [],
  selectedMenu,
  flow,
  companyId,
  isPayrollCalenderRequire,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <ul className="manage-company-menu">
      {menuList.map((item) => {
        const childRoutes = get(item, "childRoutes", []);
        let className =
          selectedMenu.indexOf(item.path) !== -1 ||
          childRoutes.filter((route) => {
            return selectedMenu.indexOf(route) !== -1;
          }).length
            ? "selected"
            : "";
        className =
          !companyId &&
          item.path !== MANAGE_COMPANY_ROUTES.INCORPORATION_DETAILS
            ? `${className} disabled`
            : className;

        className =
          !isPayrollCalenderRequire &&
          item.path === MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR
            ? `${className} d-none`
            : className;
        return (
          tenantConfig.companySubMenu.includes(item.id) &&
          permissions[roleName].companySubMenu[item.id] && (
            <li key={item.path} className={className}>
              {!companyId ? (
                item.label
              ) : (
                <>
                  <FontAwesomeIcon icon={faDiamond} size="1x" />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Link
                    to={getPathWithParam({
                      path: item.path,
                      pathParam: [FLOW_TYPES.EDIT, companyId],
                    })}
                  >
                    {item.label}
                  </Link>
                </>
              )}
              {/* <span className="open-rounded-corner-top" />
              <span className="open-rounded-corner-bottom" /> */}
            </li>
          )
        );
      })}
    </ul>
  );
};

export default ManageCompanyMenu;
